var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"mb-4 project-state-card",attrs:{"title":_vm.$t('info')}},[(_vm.shouldShowManagementSystemWarning)?_c('div',{},[_c('div',{staticClass:"warning-toast"},[_vm._v(" "+_vm._s(_vm.$t('solar_plant_gt_7kwp_warning'))+" ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }